import { render, staticRenderFns } from "./SnippetAccordion.vue?vue&type=template&id=7fb9122c"
import script from "./SnippetAccordion.vue?vue&type=script&lang=js"
export * from "./SnippetAccordion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SnippetAccordionItem: require('/var/www/vhosts/anothercodeproject.eu/jgast.anothercodeproject.eu/components/snippets/SnippetAccordionItem.vue').default})
